export default __webpack_public_path__ + "static/media/NC_1024x1024_short.6448beb6.png";